import { Instagram, MapPin, Monitor } from "lucide-react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "@/lib/config";

const Footer = () => {
  return (
    <footer
      className="bg-[#2A1A16] py-14 text-[#FDFBF7]"
      data-testid="footer"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 md:grid-cols-3 md:px-12">
        <div>
          <p className="font-serif text-2xl">
            Dra. <em className="italic text-[#D4AF37]">Mariana Alves</em>
          </p>
          <p className="mt-3 text-sm text-[#FDFBF7]/70">
            Medicina dedicada à saúde, energia e propósito da mulher.
          </p>
        </div>

        <div>
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Atendimento
          </p>
          <ul className="space-y-2 text-sm text-[#FDFBF7]/80">
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-[#D4AF37]" />
              Mogi Guaçu — SP
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-[#D4AF37]" />
              Artur Nogueira — SP
            </li>
            <li className="flex items-center gap-2">
              <Monitor className="h-4 w-4 text-[#D4AF37]" />
              Online para todo o Brasil
            </li>
          </ul>
        </div>

        <div>
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Siga
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-[#FDFBF7]/90 transition-colors hover:text-[#D4AF37]"
            data-testid="footer-instagram"
          >
            <Instagram className="h-5 w-5" />
            {INSTAGRAM_HANDLE}
          </a>
          <p className="mt-6 text-xs text-[#FDFBF7]/50">
            Conteúdo informativo. Não substitui consulta médica.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 px-6 pt-6 md:px-12">
        <p className="text-center text-xs text-[#FDFBF7]/50">
          © {new Date().getFullYear()} Dra. Mariana Alves. Todos os direitos
          reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
